import { baseURL, clients } from "../utils/Constants";
import { Buffer } from "buffer";

export const getTokens = async (codeType: string, code: string, channel: string) => {
    const codeKey = codeType === "authorization_code" ? "code" : "refresh_token";
    const details = {
        [codeKey]: code,
        "grant_type": codeType,
        "redirect_uri": baseURL + "admin/authcode",
    };

    const tempBody: any[] = [];
    for (const property in details) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(details[property]);
        tempBody.push(encodedKey + "=" + encodedValue);
    }
    const formBody: string = tempBody.join("&");

    const res = await fetch("https://authentication.logmeininc.com/oauth/token", {
        method: "POST",
        body: formBody,
        headers: {
            "Authorization": `Basic ${Buffer.from(`${clients[channel].id}:${clients[channel].secret}`, "utf8").toString("base64")}`,
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "application/json",
        },
    });
    if (!res.ok) {
        return;
    }
    const data = await res.json();
    let payload = JSON.parse(localStorage.getItem("tokens"));
    if (payload === null) {
        payload = {};
    }
    payload = {
        "access_token": data.access_token,
        "access_token_expire_date": (Date.now() + 3600 * 1000).toString(),
        "refresh_token": data.refresh_token !== undefined ? data.refresh_token : payload.refresh_token,
    };
    localStorage.setItem("tokens", JSON.stringify(payload));
    localStorage.setItem("channel", channel);
};
